/* Memoré · keeps "included" birth-month bookmarks in sync with the cart.
   1 bloom      → nothing added (the $5 add-on stays optional)
   2–4 blooms   → one $0 bookmark per bloom, matching each bloom's month
   5+ blooms    → one 12-month set (the variant that is not a month name) instead
   At 2+ blooms, any paid add-on bookmarks are removed (they are now included). */
(function () {
  var CREAM = '366-bloom-perfumed-hand-cream';
  var PAID = 'botanical-bookmark-single';
  var INCLUDED = 'birth-month-bookmark-included';
  var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  var cfg = window.MemoreIncluded || {};
  var months = cfg.months || {};
  var setId = null;
  Object.keys(months).forEach(function (k) { if (MONTH_NAMES.indexOf(k) === -1) setId = months[k]; });
  if (!Object.keys(months).length) return;

  var running = false;
  var again = false;

  function json(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) { return r.json(); });
  }

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function sectionIds() {
    var d = drawerEl();
    return d && typeof d.getSectionsToRender === 'function'
      ? d.getSectionsToRender().map(function (s) { return s.id; })
      : [];
  }

  function render(state) {
    if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    var d = drawerEl();
    if (!d || !state || !state.sections) return;
    d.getSectionsToRender().forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!el || !state.sections[s.id]) return;
      el.innerHTML = d.getSectionInnerHTML(state.sections[s.id], s.selector);
    });
    var overlay = d.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', d.close.bind(d));
  }

  function plan(cart) {
    var items = cart.items || [];
    var count = 0;
    var desired = {};

    items.forEach(function (l) { if (l.handle === CREAM) count += l.quantity; });

    if (count >= 5 && setId) {
      desired[setId] = 1;
    } else if (count >= 2) {
      items.forEach(function (l) {
        if (l.handle !== CREAM) return;
        var date = (l.properties && l.properties['Selected Date']) || '';
        var id = months[String(date).split(' ')[0]];
        if (id) desired[id] = (desired[id] || 0) + l.quantity;
      });
    }

    var updates = {};
    var seen = {};
    items.forEach(function (l) {
      if (l.handle === INCLUDED) {
        var want = desired[l.variant_id] || 0;
        if (seen[l.variant_id]) want = 0;
        seen[l.variant_id] = true;
        if (l.quantity !== want) updates[l.key] = want;
      } else if (count >= 2 && l.handle === PAID && l.properties && l.properties.For) {
        updates[l.key] = 0;
      }
    });

    var adds = Object.keys(desired)
      .filter(function (id) { return !seen[id]; })
      .map(function (id) { return { id: Number(id), quantity: desired[id] }; });

    return { updates: updates, adds: adds };
  }

  function reconcile() {
    if (running) { again = true; return; }
    running = true;
    json('/cart.js')
      .then(function (cart) {
        var p = plan(cart);
        var hasUpdates = Object.keys(p.updates).length > 0;
        if (!hasUpdates && !p.adds.length) return null;
        var sections = sectionIds();
        var chain = Promise.resolve(null);
        if (hasUpdates) {
          chain = chain.then(function () {
            return json('/cart/update.js', p.adds.length ? { updates: p.updates } : { updates: p.updates, sections: sections });
          });
        }
        if (p.adds.length) {
          chain = chain.then(function () {
            return json('/cart/add.js', { items: p.adds, sections: sections });
          });
        }
        return chain;
      })
      .then(function (state) { if (state) render(state); })
      .catch(function (e) { console.warn('[Memore] cart sync', e); })
      .finally(function () {
        running = false;
        if (again) { again = false; reconcile(); }
      });
  }

  function boot() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { reconcile(); });
    }
    reconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
